import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Centers } from '../../models/Centers';
import { CentersService } from '../../services/CentersServices';
import { AddCentersComponent } from '../add-centers/add-centers.component';
import { CentersDetailsComponent } from '../centersdetails/centersdetails.component';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-centersdetails',
  templateUrl: './get-centersdetails.component.html',
  styleUrls: ['./get-centersdetails.component.scss'],
})
export class GetCentersComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: CentersService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  intitForm() {
    this.form = this.fb.group({
      name: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.name && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاء اختيار العنوان  لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.name) {
      serchTermArr.push(`name:${this.form.value.name.trim()}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['name'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  add() {
    this.dialog
      .open(AddCentersComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.toast.show('تم الاضافة بنجاح', '', { status: 'success', duration: 3000 });
          this.loadEntities();
        }
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(CentersDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddCentersComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
